import { useReducer } from "react";

export const modalAction = {
	OPEN: "open",
	CLOSE: "close",
};

const initialModalState = {
	open: false,
	data: {},
};

const modalReducer = (state, action) => {
	switch (action.type) {
		case modalAction.OPEN:
			return { ...state, data: action.payload, open: true };
		case modalAction.CLOSE:
			return initialModalState;
		default:
			throw new Error("Invalid action at modalReducer");
	}
};

const useModalReducer = () => {
	const [state, dispatch] = useReducer(modalReducer, initialModalState);
	return { state, dispatch, actions: modalAction };
};

export default useModalReducer;
